import { render, staticRenderFns } from "./SingleJournalKeyNumberRow.vue?vue&type=template&id=3c8d54c2&scoped=true"
import script from "./SingleJournalKeyNumberRow.vue?vue&type=script&lang=js"
export * from "./SingleJournalKeyNumberRow.vue?vue&type=script&lang=js"
import style0 from "./SingleJournalKeyNumberRow.vue?vue&type=style&index=0&id=3c8d54c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d54c2",
  null
  
)

export default component.exports